import React, { PropsWithChildren } from 'react';
import { Textarea, ValidationProps } from 'ui';

interface ExternalUrlTextProps {
  id: string;
  value: string;
  labelText: string;
  validation?: ValidationProps;
  onChange?: (value: string) => void;
}

export const ExternalUrlText = ({
  id, value, labelText, validation, onChange
}: PropsWithChildren<ExternalUrlTextProps>) =>
  <Textarea
    componentId={id}
    onChange={onChange}
    readOnly={true}
    value={value}
    label={{ text: labelText }}
    validation={validation} />;
